import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Alert, Statistic } from "antd";
import GeneralDetails from "../Components/GeneralDetails";
import { DataProvider } from "../../DataProvider";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import ProgressModal from "../../../App/Utils/ProgressModal";
import Progress from "../RequestFeedback/Components/Progress";
import SafetyFeedback from "../Components/SafetyFeedback";
import QualityFeedback from "../Components/QualityFeedback";
import ScheduleFeedback from "../Components/ScheduleFeedback";
import DisciplineFeedback from "../Components/DisciplineFeedback";
import ImprovementFeedback from "../Components/ImprovementFeedback";
import { ArrowLeftOutlined, ArrowRightOutlined, SaveOutlined } from '@ant-design/icons';
import moment from "moment";

const SubmitFeedbackForm = ({ history, location }) => {
    const dataProvider = new DataProvider();
    const formRef = useRef();
    const safetyFormRef = useRef();
    const qualityFormRef = useRef();
    const scheduleFormRef = useRef();
    const disciplineFormRef = useRef();
    const improvementFormRef = useRef();
    const [state, setState] = useState({
        initialValues: { scores: [] },
        showProgress: true,
        routeName: location.pathname.split("/").pop(),
    });
    const [scoreValues, setScoreValues] = useState({})

    useEffect(() => {
        setState({ ...state, showProgress: true })
        dataProvider.getFeedback(state.routeName)
            .then(response => {
                if (response.ok) {
                    response.json().then(responseJson => {
                        if (responseJson['data']['status'] === 'Completed') {
                            history.replace('/ViewFeedback/' + state.routeName)
                        }
                        responseJson['data']['evaluation_period'] = moment(responseJson['data']['evaluation_period'], 'YYYY-MM-DD')
                        setState({ ...state, initialValues: responseJson['data'], showProgress: false })
                    })
                } else {
                    setState({ ...state, showProgress: false })
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                setState({ ...state, showProgress: false })
                openNotification("error", "Error", "Error connecting server")
            })

    }, [])

    const onFinish = (values) => {
        setState({ ...state, showProgress: true })
        const formData = new FormData()
        const payload = {
            'feedback_score_data': scoreValues,
            'status': values['status']
        }
        formData.append('data', JSON.stringify(payload))
        let api = dataProvider.submitFeedback
        if (state.initialValues.scores.length > 0) {
            api = dataProvider.updateFeedback
        }
        api(state.routeName, formData).then(response => {
            setState({ ...state, showProgress: false })
            if (response.ok) {
                response.json().then(responseJson => {
                    openNotification("success", "Success", responseJson["message"])
                    if (values['status']) {
                        history.replace('/ViewFeedback/' + responseJson['id'])
                    } else {
                        window.location.reload()
                    }

                })
            } else {
                response.json().then(responseJson => {
                    openNotification("error", "Error", responseJson["message"])
                })
            }
        }).catch(error => {
            setState({ ...state, showProgress: false })
            openNotification("error", "Error", "Error connecting server")
        })
    };

    useEffect(() => { }, [state]);

    useEffect(() => { }, [scoreValues]);

    const updateScore = (step, values) => {
        setScoreValues(prevScoreValues => {
            return { ...prevScoreValues, [step]: values };
        });
    }

    return (
        <>
            <div className="form-box" style={{ padding: "10px" }}>
                <Button onClick={() => history.replace('/AllFeedback')}>Back</Button>
            </div>
            {state.showProgress &&
                <ProgressModal showProgress={true} />}
            {Object.values(state.initialValues).length > 1 && <>
                {state.initialValues.hasOwnProperty('applicable_inputs') && state.initialValues['applicable_inputs'].length > 0 &&
                    <Alert
                        style={{ margin: "10px" }}
                        message={"Inputs required for " + state.initialValues['applicable_inputs'].join(", ")}
                        type="info"
                        showIcon
                    />}
                <Form
                    ref={formRef}
                    initialValues={state.initialValues}
                    className="ant-form ant-form-vertical"
                    onFinish={onFinish}
                    scrollToFirstError={true}
                    encType="multipart/form-data"
                >
                    <div className="row form-box" style={{ paddingTop: "10px" }}>
                        <GeneralDetails formRef={formRef} disabled={true} initialValues={state.initialValues} />
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <Form
                                className="ant-form ant-form-vertical"
                                ref={safetyFormRef}
                                scrollToFirstError={true}
                                encType="multipart/form-data"
                            >
                                <SafetyFeedback
                                    initialValues={state.initialValues}
                                    disabled={!state.initialValues['applicable_inputs'].includes('Safety')}
                                    updateScore={updateScore} />
                            </Form>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <Form
                                className="ant-form ant-form-vertical"
                                ref={qualityFormRef}
                                scrollToFirstError={true}
                                encType="multipart/form-data"
                            >
                                <QualityFeedback
                                    initialValues={state.initialValues}
                                    disabled={!state.initialValues['applicable_inputs'].includes('Quality')}
                                    updateScore={updateScore} />
                            </Form>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <Form
                                className="ant-form ant-form-vertical"
                                ref={scheduleFormRef}
                                scrollToFirstError={true}
                                encType="multipart/form-data"
                            >
                                <ScheduleFeedback
                                    initialValues={state.initialValues}
                                    disabled={!state.initialValues['applicable_inputs'].includes('Time Schedule')}
                                    updateScore={updateScore} />
                            </Form>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <Form
                                className="ant-form ant-form-vertical"
                                ref={disciplineFormRef}
                                scrollToFirstError={true}
                                encType="multipart/form-data"
                            >
                                <DisciplineFeedback
                                    initialValues={state.initialValues}
                                    disabled={!state.initialValues['applicable_inputs'].includes('Discipline & Compliance')}
                                    updateScore={updateScore} />
                            </Form>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <Form
                                className="ant-form ant-form-vertical"
                                ref={improvementFormRef}
                                scrollToFirstError={true}
                                encType="multipart/form-data"
                            >
                                <ImprovementFeedback
                                    initialValues={state.initialValues}
                                    disabled={!state.initialValues['applicable_inputs'].includes('Improvement & Initiative')}
                                    updateScore={updateScore} />
                            </Form>
                        </div>
                    </div>
                    <br />
                    <div style={{ textAlign: "right", marginRight: "15px" }}>
                        {(!state.initialValues.hasOwnProperty('id') || state.initialValues['applicable_inputs'].length > 0) &&
                            <Button
                                htmlType="submit"
                                type="primary">{(state.initialValues['is_program_head'] || state.initialValues['is_project_head']) ? "Update Feedback" : "Submit Feedback"}
                            </Button>}
                        {state.initialValues['is_project_head'] && state.initialValues['status'] !== 'Under Review' &&
                            <Button
                                onClick={() => {
                                    formRef.current.validateFields().then(values => {
                                        values['status'] = 'Under Review'
                                        onFinish(values)
                                    })
                                }}
                                style={{ background: "green", marginLeft: "15px" }}
                                type="primary">Send for Review
                            </Button>}
                        {state.initialValues['is_program_head'] && state.initialValues['status'] !== 'Completed' &&
                            <Button
                                onClick={() => {
                                    formRef.current.validateFields().then(values => {
                                        values['status'] = 'Completed'
                                        onFinish(values)
                                    })
                                }}
                                style={{ background: "green", marginLeft: "15px" }}
                                type="primary">Complete Rating
                            </Button>}
                    </div>
                </Form>
            </>}
        </>
    );
};

export default SubmitFeedbackForm;
